import React from 'react';
import { CARD_BASE, CARD_VARIANTS } from '../../constants';

/**
 * A shared card component that provides consistent styling across the application.
 * 
 * @param {Object} props
 * @param {string} [props.variant='default'] - The card variant to use (dense, compact, spacious)
 * @param {string} [props.className] - Additional CSS classes to apply
 * @param {React.ReactNode} props.children - The card content
 * @param {boolean} [props.noPadding=false] - Whether to remove padding
 * @param {Object} [props.style] - Additional inline styles
 * @returns {JSX.Element}
 */
export default function Card({ 
  variant = 'default',
  className = '',
  children,
  noPadding = false,
  style = {},
  ...props 
}) {
  const baseClasses = variant === 'default' ? CARD_BASE : CARD_VARIANTS[variant] || CARD_BASE;
  const classes = noPadding 
    ? baseClasses.replace(/p-[0-9]|p-\[.*?\]|p[xy]-[0-9]|p[xy]-\[.*?\]/g, '')
    : baseClasses;

  return (
    <div
      className={`${classes} ${className}`.trim()}
      style={style}
      {...props}
    >
      {children}
    </div>
  );
}
